import { getManifestByName } from '@/scripts/pages/video/Player/InPlayerOverlays/implementation/manifest';
import { Model } from '@viddsee/server-api-client';
import { VideoPlayerService } from '../../state';
import { VideoPlayerActionContext } from '../../types';

type Ctx = VideoPlayerActionContext;

const CREDIT_START_DELAY_SECOND = 2;
const CREDIT_START_DEFAULT_SECOND = 10;

const isInCreditTime = (video: Model.Video.Info) => (params: jwplayer.TimeParam): boolean => {
  const { duration, position } = params;
  const videoPosition = position;
  const videoDuration = duration;
  const creditStartPosition = video.creditsStart;

  if (!videoDuration) return false;

  return (creditStartPosition)
    ? videoPosition > (creditStartPosition + CREDIT_START_DELAY_SECOND)
    : (videoDuration - videoPosition) < CREDIT_START_DEFAULT_SECOND
  ;
};

export const WatchNextServiceName = Symbol('WatchNextService');

export const registerWatchNextService = (context: Ctx): VideoPlayerService => {
  const player = context.getters.player;
  if (!player) {
    return {
      name: WatchNextServiceName,
    };
  }

  const isInVideoCreditTime = isInCreditTime(context.rootState.video.video);

  let shouldShowOverlay = false;
  const changeOverlayVisibility = (shouldShow: boolean): void => {
    if (shouldShowOverlay === shouldShow) return;
    shouldShowOverlay = shouldShow;

    const watchNextOverlay = getManifestByName('WatchNextOverlay');
    const downloadAppOverlay = getManifestByName('DownloadApp');

    if (shouldShowOverlay) {
      const inPlayerOverlays = context.state.controls.inPlayerOverlays.concat(watchNextOverlay, downloadAppOverlay);
      context.commit('setInPlayerOverlays', inPlayerOverlays);
    } else {
      const inPlayerOverlays = context.state.controls.inPlayerOverlays.filter(x => x !== watchNextOverlay && x !== downloadAppOverlay);
      context.commit('setInPlayerOverlays', inPlayerOverlays);
    }
  };

  const timeHandler = (params: jwplayer.TimeParam): void => {
    changeOverlayVisibility(isInVideoCreditTime(params));
  };

  player.on('time', timeHandler);

  return {
    name: WatchNextServiceName,
    destroy(): void {
      player.off('time', timeHandler);
    },
  };
};
